;(() => {
  const MOBILE_MQ = window.matchMedia('(max-width: 767px)');
  const isMobile = () => MOBILE_MQ.matches;

  function applyColumnClasses(root = document) {
    const items = root.querySelectorAll('.shop__grid-item');
    items.forEach((item, index) => {
      item.classList.remove('col-1', 'col-2');
      if ([2, 7].includes(index % 10)) item.classList.add('col-1');
      else item.classList.add('col-2');
    });
  }
  window.applyColumnClasses = window.applyColumnClasses || applyColumnClasses;

  function watchProductsGrid(scope = document) {
    const grid = scope.querySelector('.shop__products');
    if (!grid || grid.__colObserver) return;

    // Première passe
    if (isMobile()) {
      requestAnimationFrame(() => window.applyColumnClasses(grid));
    }

    const mo = new MutationObserver((muts) => {
      if (!isMobile()) return;
      let changed = false;
      for (const m of muts) {
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          changed = true;
          break;
        }
      }
      if (changed) {
        if (mo.__raf) cancelAnimationFrame(mo.__raf);
        mo.__raf = requestAnimationFrame(() => window.applyColumnClasses(grid));
      }
    });

    mo.observe(grid, { childList: true, subtree: true });
    grid.__colObserver = mo;
  }

  // Quand on change de viewport (ex: rotation)
  MOBILE_MQ.addEventListener?.('change', () => {
    const grid = document.querySelector('.shop__products');
    if (!grid) return;
    if (isMobile()) {
      requestAnimationFrame(() => window.applyColumnClasses(grid));
    }
  });

  // Boot = applique + observe
  const boot = () => {
    window.applyColumnClasses(document);
    watchProductsGrid(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Quand on revient sur la page (back/forward cache)
  window.addEventListener('pageshow', () => {
    requestAnimationFrame(boot);
  }, { passive: true });

  // Quand une section Shopify se recharge
  document.addEventListener?.('shopify:section:load', (e) => {
    window.applyColumnClasses(e.target);
    watchProductsGrid(e.target);
  });
})();
